'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { EntityTypes } from 'AdsUI/lib/Constants';

class SequenceEntityRecord extends Record({
  id: null,
  name: null,
  portalId: null,
  network: null,
  accountId: null,
  type: EntityTypes.SEQUENCE,
  attractCreatedAdId: null,
  convertCreatedAdId: null,
  closeCreatedAdId: null,
  status: null,
  attractAdEndType: null,
  numOfDaysEndAttractAd: null,
  numOfEngagementsEndAttractAd: null,
  convertAdStartType: null,
  convertAdEndType: null,
  numOfDaysEndConvertAd: null,
  numOfEngagementsStartConvertAd: null,
  numOfContactsEndConvertAd: null,
  closeAdStartType: null,
  closeAdEndType: null,
  audienceSizeStartCloseAd: null,
  numOfDaysEndCloseAd: null,
  numOfContactsStartCloseAd: null,
  numOfContactsEndCloseAd: null,
  schedulingCompletedAt: null,
  createdAt: null
}) {
  constructor(_ref = {}) {
    let {
      adNetwork,
      adAccountId
    } = _ref,
        args = _objectWithoutPropertiesLoose(_ref, ["adNetwork", "adAccountId"]);

    super(Object.assign({
      network: adNetwork,
      // For consistency with other entity networks
      accountId: adAccountId
    }, args));
  }

}

export default SequenceEntityRecord;